import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

import hotelSearchParams from "./Search/search";
import searchFilters from './Search/filters'
import sort from "./Search/sort";

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    getters: {},
    modules: {
        hotelSearchParams,
        searchFilters,
        sort
    }
})
